import { forwardRef } from "react";
import InputField from "./InputField.js";

const EmailField = forwardRef(function (props, ref) {
  return <InputField type="email" {...props} />;
});
EmailField.displayName = "EmailField";

export default EmailField;
